import { uploadEventList } from "$common/utils/event-tracking/page";
import { isWownowApp } from '$common/utils/common'
import storage from '$common/utils/storage';

export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router);
    const { routerPreFix } = require('$proDirname/prefix');
    //  设置 spa 的路由前缀
    const prefix = window?.ssrConfig?.routerConfig?.name ?? `/${routerPreFix.storePreview}/index`;

    const router = new Router({
      mode: 'history',
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/store-preview`
        },
        {
          name: 'store-preview',
          path: `${prefix}/store-preview`,
          component: resolve => import('./store-preview/store-preview').then(resolve)
        },
        {
          name: 'store-info-page',
          path: `${prefix}/store-info-page`,
          component: resolve => import('./store-info-page').then(resolve)
        },
      ]
    });

    return router;
  }
};
